import * as enums from '@/enums';
import { ProjectType } from '@/enums';
import type { ProjectBase } from '@/types';

export function canArchive(item: Pick<ProjectBase, 'projectStatusId'>) {
  const statuses = [
    enums.ProjectStatus.Active,
  ];

  return statuses.includes(item.projectStatusId);
}

export function canActivate(item: Pick<ProjectBase, 'projectStatusId'>) {
  const statuses = [
    enums.ProjectStatus.Archived,
  ];

  return statuses.includes(item.projectStatusId);
}

export function canManage(item: Pick<ProjectBase, 'projectStatusId'>) {
  const statuses = [
    enums.ProjectStatus.Active,
    enums.ProjectStatus.Draft,
  ];

  return statuses.includes(item.projectStatusId);
}

// export function canEditSurvey(item: Pick<ProjectBase, 'isExternal' | 'projectStatusId' | 'projectTypeId'>) {
//   const statuses = [
//     enums.ProjectStatus.Active,
//   ];
//   const types = [
//     enums.ProjectType.Survey,
//     enums.ProjectType.SurveyCall,
//   ];

//   if (item.isExternal && item.projectType === enums.ProjectType.Survey) return false;

//   return true;
// }

// export function canClone(item: Pick<ProjectParent, 'frequency'>) {
//   return item.frequency !== enums.ProjectFrequency.None;
// }

export function isSurveyLike(item: Pick<ProjectBase, 'projectTypeId'>) {
  return item.projectTypeId != ProjectType.Call;
}

export function isCallLike(item: Pick<ProjectBase, 'projectTypeId'>) {
  return item.projectTypeId != ProjectType.Survey;
}

// export function canDownload(item: Pick<ProjectBase, 'isExternal'>) {
//   return !item.isExternal;
// }

export function canShare(item: Pick<ProjectBase, 'projectStatusId'>) {
  const statuses = [
    enums.ProjectStatus.Active,
  ];

  return statuses.includes(item.projectStatusId);
}

// export function canPreview(item: Pick<ProjectBase, 'isExternal' | 'projectTypeId'>) {
//   return !item.isExternal && isSurveyLike(item);
// }

export function canMonitorSurvey(item: Pick<ProjectBase, 'projectTypeId'>) {
  return [enums.ProjectType.Survey, enums.ProjectType.SurveyCall].includes(item.projectTypeId);
}